import { render, staticRenderFns } from "./PartRequestOrderButton.vue?vue&type=template&id=16efd68b"
import script from "./PartRequestOrderButton.vue?vue&type=script&lang=ts"
export * from "./PartRequestOrderButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports